<template>
    <v-container grid-list-lg>
        <v-layout wrap>
            <v-flex xs12 sm12 md4>
                <v-btn
                    block
                    nuxt
                    depressed
                    :ripple="{ class: 'ripple_highlight' }"
                    color="white"
                    class="categories_button"
                    @click="$vuetify.goTo('#category_1', options)"
                >
                    すべての<br>ユーザーの方むけ
                </v-btn>
            </v-flex>
            <v-flex xs12 sm12 md4>
                <v-btn
                    block
                    nuxt
                    depressed
                    :ripple="{ class: 'ripple_highlight' }"
                    color="white"
                    class="categories_button"
                    @click="$vuetify.goTo('#category_2', options)"
                >
                    プロジェクトを行う<br>プレゼンターの方むけ
                </v-btn>
            </v-flex>
            <v-flex xs12 sm12 md4>
                <v-btn
                    block
                    nuxt
                    depressed
                    :ripple="{ class: 'ripple_highlight' }"
                    color="white"
                    class="categories_button"
                    @click="$vuetify.goTo('#category_3', options)"
                >
                    プロジェクトを支援する<br>コレクターの方むけ
                </v-btn>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    name: 'CategoriesMenu',
    data: () => ({
        options: {
            duration: 700,
            offset: 20,
            easing: 'easeInOutCubic'
        }
    })
}
</script>
